module.exports = require("xml-but-prettier");